<template>
    <div class="coffee-card">
        <div class="size-tab-wrapper">
            <template v-if="this.coffee.product_custom_sizes !== undefined && this.coffee.product_custom_sizes.length > 0">
                <div v-for="name in getSizeName" @click="customSizeSelected = name, detailPageSize(customSizeSelected), customGrindSelected = onboarding ? defaultGrind : customGrindSelected" :class="{'size-tab-non-active': customSizeSelected !== name}">
                    {{ getProductDisplaySize(coffee, name) }}
                </div>
            </template>
        </div>

        <div>
            <div v-if="this.coffee.product_custom_sizes !== undefined && this.coffee.product_custom_sizes.length > 0">
                <div v-for="(name, index) in getSizeName" >
                    <h1 v-if="customSizeSelected === name" class="price">
                        <span v-show="customSizeSelected !== name" class="original-price font-sm">{{ customSizePrice(name) }}</span>
                        <span v-if="onboarding" class="crossed-out-amount">    {{ formatPrice(finalCustomPrice) }} </span>
                        {{ formatPrice(finalCustomPriceDiscounted) }}
                        <span class="font-green font-md">free shipping</span>
                    </h1>
                </div>
            </div>
        </div>

        <div class="grind-btn-wrapper">
            <div v-if="coffee.product_custom_sizes != undefined  && coffee.product_custom_sizes.length > 0" class="w-100">
                <span v-for="(name, index) in getSizeName">
                    <span v-if="customSizeSelected === name">
                    <div v-if="customGrindType(name) != undefined " class="custom-grind-wrapper">
                        <div v-for="(grind, index) in all_grinds" :key="index"
                            class="grind-btn"
                            :class="{'grind-btn-active': customGrindSelected === grind, 'disabled': !customGrind.includes(grind)}"
                            @click="customGrindSelected = grind">

                            {{ humanizeGrind(grind) }}
                        </div>
                    </div>
                    </span>
                </span>
            </div>
        </div>

        <!-- Decaf Indicator -->
        <div v-if="coffee.is_decaf" class="decaf-tag">decaf</div>
        <div v-if="coffee.espresso" class="espresso-tag">espresso</div>
        <div v-else-if="coffee.cold_brew" class="cold-brew-tag">cold brew</div>

        <a data-track-click="Click on coffee"
           data-track-description="Result thumbnail"
           :data-track-id="coffee.id"
           :data-track-name="coffee.name"
           :href="coffeeUrl">
            <figure class="flavor-img" :class="getFlavorImageClass()">
                <noscript></noscript>
                <transition name="fade">
                    <img :src="getFlavourImageUrl(coffee)" v-on:load="flavorImgLoaded = true" v-show="flavorImgLoaded">
                </transition>
            </figure>
        </a>

        <a v-if="!coffee.is_sampler" :href="sellerUrl">
            <figure class="roaster-logo-wrapper">
                <transition name="fade">
                    <img class="roaster-logo" v-bind:src="seller.logo_image" v-on:load="roasterImgLoaded = true" v-show="roasterImgLoaded">
                </transition>
            </figure>
        </a>

        <div class="coffee-name">
            <a data-track-click="Click on coffee"
               data-track-description="Result title"
               :data-track-id="coffee.id"
               :data-track-name="coffee.name"
               :href="coffeeUrl">
                {{ coffee.name }}
            </a>
        </div>

        <div class="tasting-note-wrapper">
            <span v-for="(note, index) in coffee.tasting_notes" :key="index">
                {{ note.toLowerCase() }}
                <span v-if="index < coffee.tasting_notes.length - 1"> | </span>
            </span>
        </div>

        <p>{{ getRoastLevel(coffee.coffee_roast) }}</p>

        <template v-if="!onboarding">
            <div class="bottom-btn-wrapper">
                <div class="buy-now-btn" @click="buyNow()">
                    <span class="buy-now-btn-label">buy now</span>
                    <div class="clip-path-inner"></div>
                </div>
                <div v-if="coffee.product_custom_sizes != undefined && brewlistGrind.grind != null"
                     :id="'add-to-brewlist' + coffee.id"
                     class="add-btn"
                     ref="addBtn"
                     :data-product-id="coffee.id"
                     :data-product-size="customSizeSelected"
                     :data-product-grind="customGrindSelected"
                     :class="(addedToPlaylist || coffee.is_added_to_playlist) ? 'active' : ''"
                     @click="confirmCustomGrind()">
                    <div class="clip-path-inner"></div>
                    <span class="add-btn-label"></span>
                </div>
                <div v-if="brewlistGrind.grind === null" class="add-btn" id="add-to-brewlist">
                    <a href="/users/sign_in"><div class="clip-path-inner"></div>
                    <span class="add-btn-label-null"></span></a>
                </div>

                <div class="send-to-friend-btn" @click="buyNow(true)">
                    <span class="send-to-friend-btn-label">send to friend</span>
                    <div class="clip-path-inner"></div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="buy-now-btn buy-now-btn-onboarding" @click="buyNow()">
                <span class="buy-now-btn-label">choose</span>
                <div class="clip-path-inner"></div>
            </div>
        </template>
    </div>
</template>

<script>
    import CommonMixin from '../../mixins/common-mixin';
    import CoffeeMixin from '../../mixins/coffee-mixin';

    export default {
        name: 'coffee-card',
        mixins: [
            CommonMixin,
            CoffeeMixin
        ],
        props: {
            coffee: Object,
            seller: Object,
            paramfilter: Object,
            defaultGrind: String,
            onboarding: Boolean,
            taxRate: Number,
            measureUnit: String,
            defaultSize: Array,
            brewlistGrind:Object,
            addedToPlaylist: Boolean
            // addedToPlaylist: Boolean // TODO: This property will be used to toggle the playlist button when replacing add.js.
        },
        data: function () {
            return {
                sizeSelected: undefined,
                grindSelected: undefined,
                all_grinds: ['whole_bean', 'course', 'medium', 'fine' ],
                flavorImgLoaded: false,
                roasterImgLoaded: false,
                customGrindSelected: undefined,
                customSizeSelected: undefined,
                customFinalPrice: undefined,
                customGrindName: undefined,
                filterSize: [],
                brewqueueSizes: [],
                onSizeTab: []
            }
        },
        methods: {
            detailPageSize: function(name) {
                window.localStorage.setItem("sizeName",this.customSizeSelected);
            },
            confirmGrind() {
                // HACK
                if (this.addBtnElem.hasClass('active')) {
                    return;
                }

                if (this.grindSelected != this.brewlistGrind.grind) {
                    this.$emit('confirm-grind', this.coffee.id, this.grindSelected);
                } else {
                    this.addBtnElem.trigger('add');
                }
                // this.$emit('add-to-playlist', this.coffee.id, this.sizeSelected, this.grindSelected);
            },
            confirmCustomGrind() {
                if (this.addBtnElem.hasClass('active')) {
                    return;
                }
                if (this.customGrindSelected != this.brewlistGrind.grind) {
                    this.$emit('confirm-grind', this.coffee.id, this.customGrindSelected, this.brewlistGrind.grind);
                } else {
                    this.addBtnElem.trigger('add');
                }
                // this.$emit('add-to-playlist', this.coffee.id, this.sizeSelected, this.grindSelected);
            },
            addToPlaylist() {
                this.addBtnElem.trigger('add');
            },
            runAnimation() {
                this.$refs.addBtn.dispatchEvent(event);
            },
            buyNow(isGift = false) {
                const order = {
                    coffeeId: this.coffee.id,
                    coffeeName: this.coffee.name,
                    size: this.customSizeSelected,
                    displaySize: this.getProductDisplaySize(this.coffee, this.customSizeSelected),
                    grind: this.customGrindSelected,
                    unitPrice: this.customFinalPrice,
                    bagImageUrl: this.customSizeSelected === '5lb' ? this.seller.largebag : this.seller.smallbag,
                    isSampler: this.coffee.is_sampler,
                    isGift: isGift
                };
                this.$emit('buy-now', order);
            },
            getFlavorImageClass() {
                let className = '';
                if (this.coffee.is_sampler) {
                    className += 'flavor-img-sampler'
                }
                if (this.onboarding) {
                    if (className.length > 0) {
                        className += ' '
                    }
                    className += 'flavor-img-without-link'
                }
                return className;
            },
            getDiscountedPrice(price_cents) {
                if (this.onboarding) {
                    price_cents -= 500;
                }
                return this.calcTaxedPriceCents(price_cents, this.taxRate);
            },
            customGrindType(name){
                if (this.measureUnit == 'metric_uom') {
                    var grindName = this.coffee.product_custom_sizes.map((m) => {return (name == m.custom_size.metric_uom) ? m.grinds : null; }).filter(f => {return (f !== null); });
                } else {
                    var grindName = this.coffee.product_custom_sizes.map((m) => {return (name == m.custom_size.imperial_uom) ? m.grinds : null; }).filter(f => {return (f !== null); });
                }
                this.customGrindName = grindName[0];
                if (this.brewlistGrind != undefined && this.customGrindName.includes(this.brewlistGrind.grind) && this.customGrindSelected === undefined ){
                    this.customGrindSelected = this.brewlistGrind.grind;
                }else{
                    this.customGrindSelected = this.customGrindSelected != undefined && this.customGrindName.includes(this.customGrindSelected) ? this.customGrindSelected : this.customGrindName[0] ;
                }
                return grindName[0];
            },
            customSizePrice(name) {
                if (this.measureUnit == 'metric_uom') {
                    var price = this.coffee.product_custom_sizes.map(p => {return (name === p.custom_size.metric_uom) ? p.price_cents : null; }).filter(f => {return (f !== null); });
                    var platformFee = this.coffee.product_custom_sizes.map((m) => {return (name == m.custom_size.metric_uom) ? m.custom_size.platform_fee.cents : null; }).filter(f => {return (f !== null); });
                } else {
                    var price = this.coffee.product_custom_sizes.map(p => {return (name === p.custom_size.imperial_uom) ? p.price_cents : null; }).filter(f => {return (f !== null); });;
                    var platformFee = this.coffee.product_custom_sizes.map((m) => {return (name == m.custom_size.imperial_uom) ? m.custom_size.platform_fee.cents : null; }).filter(f => {return (f !== null); });
                }
                this.customFinalPrice = price[0] + platformFee[0];
				return price[0] + platformFee[0];
            },
            filterName(m_unit){
                if(m_unit ==="metric_uom"){
                    var g = this.paramfilter.size.map(r=> {
                        if(!r.split("/")[1].includes('kg')){
                           return r.split("/")[1]; 
                        }
                    }).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                    this.filterSize.push(g);
                    var kg = this.paramfilter.size.map(r=> {
                        if(r.split("/")[1].includes('kg')){
                           return r.split("/")[1]; 
                        }
                    }).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                    this.filterSize.push(kg);
                }else{
                    var oz = this.paramfilter.size.map(r=> {
                        if(!r.split("/")[0].includes('lb')){
                           return r.split("/")[0]; 
                        }
                    }).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                    this.filterSize.push(oz);
                    var lb = this.paramfilter.size.map(r=> {
                        if(r.split("/")[0].includes('lb')){
                           return r.split("/")[0]; 
                        }
                    }).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                    this.filterSize.push(lb);
                }
                this.filterSize = this.filterSize.flat();
                this.filterSize = this.filterSize.filter(r=> r != undefined);
            }
        },
        computed: {
            coffeeUrl: function() {
                if (this.onboarding) {
                    return undefined;
                }
                return `/coffees/${this.seller.slug}/${this.coffee.slug}?size=${this.customSizeSelected}&grind=${this.customGrindSelected}#coffee_overview`;
            },
            sellerUrl: function() {
                if (this.onboarding) {
                    return undefined;
                }
                return '/roasters/' + this.seller.slug
            },
            customGrind: function(){
              return this.customGrindName;
            },
            addBtnElem: function() {
                return $("#add-to-brewlist"+this.coffee.id);
            },
            finalCustomPrice: function(){
                return this.customFinalPrice; 
                //return this.getDiscountedPrice(this.customFinalPrice);
            },
            finalCustomPriceDiscounted: function(){
                //return this.customFinalPrice; 
                return this.getDiscountedPrice(this.customFinalPrice);
            },
            getSizeName() {
                var name = [];
                if(this.measureUnit === 'metric_uom') {
                    var g = this.coffee.product_custom_sizes.map(r => {
                        if (!r.custom_size.metric_uom.includes('kg')) {
                            return r.custom_size.metric_uom;
                        }
                        }).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                    var kg = this.coffee.product_custom_sizes.map(r => {
                        if (r.custom_size.metric_uom.includes('kg')) {
                            return r.custom_size.metric_uom;
                        }
                        }).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                    name = g.concat(kg).filter(function( element ) {
                        return element !== undefined;
                    });
                    if(this.paramfilter != undefined && this.paramfilter.size.length > 0){
                        this.filterName(this.measureUnit);
                    }  
                }else {
                    var oz = this.coffee.product_custom_sizes.map(r => {
                    if (r.custom_size.imperial_uom.includes('oz')) {
                        return r.custom_size.imperial_uom;
                    }
                    }).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                    var lb = this.coffee.product_custom_sizes.map(r => {
                    if (r.custom_size.imperial_uom.includes('lb')) {
                        return r.custom_size.imperial_uom;
                    }
                    }).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                    name = oz.concat(lb).filter(function( element ) {
                        return element !== undefined;
                    });
                    if(this.paramfilter != undefined && this.paramfilter.size.length > 0){
                        this.filterName(this.measureUnit);
                    }  
                }
                this.onSizeTab = name;
                return name;
            }
        },
        mounted() {
            this.addBtnElem.brewlistAdd();
            this.getSizeName;

            if(this.measureUnit == 'imperial_uom'){
                this.brewqueueSizes = (this.brewlistGrind.sizes.map(r => r.split("/")[0]).sort(function(a, b){return parseFloat(a) - parseFloat(b)}));
            }else if(this.measureUnit == 'metric_uom'){
                this.brewqueueSizes = this.brewlistGrind.sizes.map(r => r.split("/")[1]).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
            }

            if (this.paramfilter != undefined && this.paramfilter.size.length > 0){
                this.customSizeSelected = this.filterSize.filter(r=> {
                    if (this.getSizeName.includes(r)){
                        return r[0];
                    }
                });
                this.customSizeSelected = this.customSizeSelected[0];

            }else if (this.onboarding){

                this.customSizeSelected = this.defaultSize.filter(r=> {
                    if (this.getSizeName.includes(r)){
                        return r;
                    }
                });
                this.customSizeSelected = this.customSizeSelected[0];
                this.customGrindSelected = this.defaultGrind;

                if(this.customSizeSelected == undefined ){
                    this.customSizeSelected = (this.getSizeName !== undefined && this.getSizeName.length > 0) ? this.getSizeName[0] : this.onSizeTab[0];
                }

            }else{
                if (this.brewqueueSizes.length > 0){
                    this.brewqueueSizes = this.brewqueueSizes.map(r => {return this.getSizeName.includes(r) ? r : 0 });
                    this.brewqueueSizes = this.brewqueueSizes.filter(r=> r != 0);
                }

                if (this.brewqueueSizes.length > 0){
                    this.customSizeSelected = this.brewqueueSizes[0];
                }else{
                    this.customSizeSelected = (this.getSizeName !== undefined && this.getSizeName.length > 0) ? this.getSizeName[0] : '';
                }
                
            }
        }

    }
</script>

<style lang="scss" scoped>
    @import "./../../styles/variables_home";
    @import "./../../styles/common_home";

    .coffee-card {
        width: 340px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 1rem auto 1.5rem auto;
        padding-bottom: 1.5rem;
        position: relative;
        box-shadow: 0 4px 6px 0 #ccc, 0 2px 10px 0 #ccc;
        p {
            margin-bottom: 1rem;
        }
        a {
            text-decoration: none;
        }
    }
    .size-tab-wrapper {
        display: flex;
        width: 100%;
        color: black;
        cursor: pointer;
        div {
            flex-grow: 1;
            text-align: center;
            padding: 0.75rem;
            font-size: 18px;
        }
    }
    .size-tab-non-active {
        background-color: $white;
    }
    .price {
        color: $green-primary;
        font-size: 26px;
        font-weight: normal;
        margin-top: 1.25rem;
        letter-spacing: -1px;
    }
    .original-price {
        font-size: 17px;
    }
    .crossed-out-amount {
      text-decoration: line-through;
    }
    .coffee-card-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 50%;
        font-size: 14px;
        border: solid 1px $color-primary;
        line-height: 1;
        box-sizing: border-box;
    }
    .grind-btn-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
}
.grind-btn-wrapper .w-100{
    width:100%;
}
    .custom-grind-wrapper {
      display: flex;
    justify-content: space-between;
    width: 80%;
    margin: 0.5rem auto 0 auto;
    padding: 0 1rem;

    }
    .grind-btn {
        @extend .coffee-card-btn;
        width: 50px;
        height: 50px;
        font-size: 14px;
        padding: 0 1px;
    }
    .grind-btn-active {
        color: white;
        background-color: $color-primary;
    }
    .disabled {
        cursor: auto;
        pointer-events: none;
        filter: grayscale(100%);
        opacity: 0.3;
    }
    .coffee-name {
        max-width: 100%;
        height: 54px;
        font-size: 20px;
        font-weight: bold;
        display: flex;
        align-items: center;
        text-align: center;
        padding: 0 20px;
    }
    .tasting-note-wrapper {
        height: 40px;
        text-align: center;
    }
    .flavor-img {
        width: 160px;
        height: 160px;
        text-align: center;
        transition: all .4s;
        &:hover {
            transform: scale(1.2);
        }
        img {
            width: 100%;
            height: 100%;
        }
    }
    .flavor-img-without-link {
        &:hover {
            transform: scale(1) !important;
        }
    }
    .flavor-img-sampler {
        width: 200px;
        height: 200px;
    }
    .decaf-tag {
        position: absolute;
        left: -4.5rem;
        top: 45%;
        background-color: $yellow;
        transform: rotate(90deg);
        font-size: 1.625em;
        font-weight: normal;
        color: $white;
        margin: 0;
        padding: 14px 48px;
        border-radius: 10px 10px 0 0;
    }
    .espresso-tag {
        position: absolute;
        right: -4.5rem;
        top: 45%;
        background-color: $yellow;
        transform: rotate(90deg);
        font-size: 1.625em;
        font-weight: normal;
        color: $white;
        margin: 0;
        padding: 14px 34px;
        border-radius: 0 0 10px 10px;
    }
    .cold-brew-tag {
        position: absolute;
        right: -4.5rem;
        top: 45%;
        background-color: $yellow;
        transform: rotate(90deg);
        font-size: 1.625em;
        font-weight: normal;
        color: $white;
        margin: 0;
        padding: 14px 24px;
        border-radius: 0 0 10px 10px;
    }
    .roaster-logo-wrapper {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background-color: #EAEAEA;
        border: solid 2px $color-primary;
        margin: auto;
    }
    .roaster-logo {
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
    .bottom-btn-wrapper {
        display: flex;
        justify-content: space-around;
        width: 90%;
        margin-top: 0.5rem;
    }
    .bottom-btn {
        @extend .coffee-card-btn;
        position: relative;
        width: 64px;
        height: 64px;
        font-size: 15px;
        font-weight: bold;
        border: solid 3px $color-primary;
        &:hover {
            /* HACK */
            .clip-path-inner {
                clip-path: circle(50%);
            }
        }
    }
    .buy-now-btn {
        @extend .bottom-btn;
        color: $color-primary;
        .clip-path-inner {
            @include clip-path-inner-circle(rgba(69, 95, 134, 0.1));
        }
    }
    .buy-now-btn-onboarding {
        width: 240px;
        height: 48px;
        border-radius: 30px;
        .clip-path-inner {
            width: 326px;
        }
    }
    .buy-now-btn-label {
        padding: 0 10px;
    }
    .add-btn {
        @extend .bottom-btn;
        color: $green-primary;
        border-color: $green-primary;
        .add-btn-label:before {
            content: 'add to brew queue';
        }
        .add-btn-label-null:before{
            content: 'add to brew queue';
            color: #50784F; 
        }
        .clip-path-inner {
            @include clip-path-inner-circle(rgba(50, 220, 115, 0.1));
        }
    }
    .send-to-friend-btn {
        @extend .bottom-btn;
        color: $gold;
        border-color: $gold;
        .clip-path-inner {
            @include clip-path-inner-circle(rgba(214, 148, 64, 0.1));
        }
    }
    .active {
        color: white;
        background-color: $green-primary;
        border: none;
        .add-btn-label:before {
            content: 'in\a brew\a queue'!important;
            white-space: pre;
            position: relative;
            top: -2px;
        }
    }


    @media only screen and (max-width: $max-mobile-width) {
        .coffee-card {
            width: 320px;
            box-shadow: 0 1px 1px 0 #ccc, 0 2px 4px 0 #ccc;
            font-size: 14px;
        }
        .coffee-name {
            font-size: 16px;
        }
    }
    @media only screen and (max-width: $max-mobile-sm-width) {
        .coffee-card {
            width: 270px;
        }
    }
</style>
